function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import * as React from 'react';
import './ttl-element.scss';
import '@ant-design/compatible/assets/index.css';
import { Input, Select, Form } from 'antd';
import { getClassNames } from '../../utils';
import { FormLayoutRow } from '../form-layout-row/form-layout-row';
export function calculateRawTtlSecondsFromValue(value, metric) {
  var computed = value;
  switch (metric) {
    case 'minutes':
      computed = computed * 60;
      break;
    case 'hours':
      computed = computed * 60 * 60;
      break;
    case 'days':
      computed = computed * 60 * 60 * 24;
      break;
  }
  return computed;
}
export function calculateValueFromRawTtlSeconds(value, metric) {
  var computed = value;
  switch (metric) {
    case 'minutes':
      computed = computed / 60;
      break;
    case 'hours':
      computed = computed / 60 / 60;
      break;
    case 'days':
      computed = computed / 24 / 60 / 60;
      break;
  }
  return computed;
}
export var TtlDisplayElement = /*#__PURE__*/function (_React$PureComponent) {
  function TtlDisplayElement() {
    _classCallCheck(this, TtlDisplayElement);
    return _callSuper(this, TtlDisplayElement, arguments);
  }
  _inherits(TtlDisplayElement, _React$PureComponent);
  return _createClass(TtlDisplayElement, [{
    key: "render",
    value: function render() {
      var _this$props$entity$de, _this$props$entity$di, _this$props$entity$di2;
      var rawTtlSeconds = (_this$props$entity$de = this.props.entity.defaultNotificationTtlSeconds) !== null && _this$props$entity$de !== void 0 ? _this$props$entity$de : null;
      var ttlMetric = (_this$props$entity$di = (_this$props$entity$di2 = this.props.entity.displayMeta) === null || _this$props$entity$di2 === void 0 ? void 0 : _this$props$entity$di2.default_notification_ttl_metric) !== null && _this$props$entity$di !== void 0 ? _this$props$entity$di : 'days';
      var ttlValue = rawTtlSeconds === null ? null : calculateValueFromRawTtlSeconds(rawTtlSeconds, ttlMetric);
      return /*#__PURE__*/React.createElement(FormLayoutRow, {
        label: this.props.label || 'Default Lifespan',
        value: rawTtlSeconds != null ? "".concat(ttlValue, " ").concat(ttlMetric.replace(/s$/, '(s)')) : 'No default',
        info: /*#__PURE__*/React.createElement("span", null, "System default is 7 days.")
      });
    }
  }]);
}(React.PureComponent);
export var TtlEditorElement = /*#__PURE__*/function (_React$Component) {
  function TtlEditorElement() {
    _classCallCheck(this, TtlEditorElement);
    return _callSuper(this, TtlEditorElement, arguments);
  }
  _inherits(TtlEditorElement, _React$Component);
  return _createClass(TtlEditorElement, [{
    key: "render",
    value: function render() {
      var _this$props$entity$di3;
      var rawDefaultTtlSeconds = this.props.entity.defaultNotificationTtlSeconds;
      var defaultTtlMetric = ((_this$props$entity$di3 = this.props.entity.displayMeta) === null || _this$props$entity$di3 === void 0 ? void 0 : _this$props$entity$di3.default_notification_ttl_metric) || 'days';
      var defaultTtlValue = calculateValueFromRawTtlSeconds(rawDefaultTtlSeconds, defaultTtlMetric);
      return /*#__PURE__*/React.createElement(Form.Item, {
        className: getClassNames('ttl-editor-element-lifespan'),
        label: this.props.label || 'Default Lifespan',
        name: "ttlValue",
        initialValue: defaultTtlValue,
        rules: [{
          required: true,
          message: 'Default lifespan is required.'
        }]
      }, /*#__PURE__*/React.createElement(Input, {
        size: "middle",
        autoComplete: "off",
        type: "number",
        min: 0,
        addonAfter: /*#__PURE__*/React.createElement(Form.Item, {
          name: ['ttlMetric'],
          initialValue: defaultTtlMetric,
          noStyle: true
        }, /*#__PURE__*/React.createElement(Select, {
          size: "middle"
        }, /*#__PURE__*/React.createElement(Select.Option, {
          value: "minutes"
        }, "minute(s)"), /*#__PURE__*/React.createElement(Select.Option, {
          value: "hours"
        }, "hour(s)"), /*#__PURE__*/React.createElement(Select.Option, {
          value: "days"
        }, "day(s)")))
      }));
    }
  }]);
}(React.Component);